module.exports = __webpack_public_path__ + "img/lp-cigarette.60bf3ec7.svg";